import {memo} from 'react';

import type {SVGProps} from 'react';

export const EditBuyerIcon = memo(function EditBuyerIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none">
        <path
          d="M28 26.6999C32.9706 26.6999 37 22.6705 37 17.6999C37 12.7294 32.9706 8.69993 28 8.69993C23.0294 8.69993 19 12.7294 19 17.6999C19 22.6705 23.0294 26.6999 28 26.6999Z"
          fill="#9FA8DA"
        />
        <path
          d="M42.5 37C42.5 49 13.5 49 13.5 37C13.5 34.8 15.3 33 17.5 33H38.5C40.7 33 42.5 34.8 42.5 37Z"
          fill="#9FA8DA"
        />
        <path
          d="M20.3 6.4C21.4 5.8 22.7 5.5 24 5.5C28.7 5.5 32.5 9.3 32.5 14C32.5 18.7 28.7 22.5 24 22.5C19.3 22.5 15.5 18.7 15.5 14C15.5 13.2 15.6 12.4 15.8 11.6"
          stroke="#18193F"
          strokeWidth={3}
          strokeMiterlimit={5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.3 42.4C15.1 41.7 9.5 38.8 9.5 33.5C9.5 31.3 11.3 29.5 13.5 29.5H29.5"
          stroke="#18193F"
          strokeWidth={3}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M34.5002 41.7L33.2002 43C33.0002 43.2 32.8002 43.3 32.6002 43.4L27.5002 44.7C26.9002 44.9 26.3002 44.3 26.5002 43.7L27.8002 38.6C27.9002 38.4 28.0002 38.2 28.2002 38L39.0002 27.3C40.4002 25.9 42.6002 25.9 44.0002 27.3C45.4002 28.7 45.4002 30.9 44.0002 32.3L38.7002 37.6"
          stroke="#18193F"
          strokeWidth={3}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M37.084 29.2869L42 34.1999"
          stroke="#18193F"
          strokeWidth={3}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
});
